import { render, staticRenderFns } from "./Xs500Gray.vue?vue&type=template&id=028c6fe4&scoped=true&"
var script = {}
import style0 from "./Xs500Gray.vue?vue&type=style&index=0&id=028c6fe4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028c6fe4",
  null
  
)

export default component.exports